module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "OklahomaState.77e1a87d.webp";